import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import * as notify from "../../../shared/notify";

import { Select } from "../../form-inputs/inputs";
import { getPegholes, savePegholes, deletePeghole } from "../lib/pegholeData";
import { pegHoleTypes } from "../lib/constants";

const PegholeMarker = (props) => {
    const { top, left, id, typeCode } = props;
    const styles = {
        top,
        left,
    };
    const handleRemove = () => {
        props.removeMarker(id);
    };
    const updateType = (name, value) => {
        props.updateType(id, value);
    };

    return (
        <div className="peghole-marker" style={styles}>
            <FontAwesomeIcon icon={faTimesCircle} onClick={handleRemove} />
            <Select name="typeCode" updateOnChange={updateType} value={typeCode} options={pegHoleTypes} disabled={props.isReadOnly}></Select>
        </div>
    );
};

class PegholeCapture extends Component {
    constructor() {
        super();
        this.state = {
            naturalHeight: 0,
            naturalWidth: 0,
            pegholes: [],
            showPeghole: true,
            isDirty: false,
        };
    }
    componentDidMount() {
        this.getExistingData();
    }
    getExistingData = async () => {
        const pegholes = await getPegholes(this.props.wipKey, this.props.shot.key);

        if (pegholes && pegholes.length > 0) {
            this.setState({
                pegholes,
                showPeghole: false,
            });
            this.props.updateHasPegholeData(true);
        }
    };
    addPeghole = (x, y) => {
        const pegholes = [
            {
                x,
                y,
                typeCode: "",
            },
            ...this.state.pegholes,
        ];

        this.setState({
            pegholes,
            isDirty: true,
        });
        this.props.updateDirtyFlag(true);
    };

    validatePegholes = () => {
        let isValid = true;
        this.state.pegholes.forEach((peghole) => {
            if (!peghole.typeCode) {
                isValid = false;
            }
        });

        return isValid;
    };

    savePegholes = () => {
        //Don't update if nothing has changed
        if (!this.state.isDirty || this.props.isReadOnly) {
            return false;
        }

        if (this.validatePegholes()) {
            if (this.state.pegholes.length > 0) {
                savePegholes(this.props.wipKey, this.props.shot.key, this.props.sourcePage, this.state.pegholes);
                this.setState({
                    showPeghole: false,
                });
            } else {
                deletePeghole(this.props.wipKey, this.props.shot.key);
            }

            this.setState({
                isDirty: false,
            });
            this.props.updateDirtyFlag(false);
        } else {
            notify.error("Peghole type missing");
        }
    };
    onLoad = (e) => {
        const $img = e.currentTarget;

        this.setState({
            naturalHeight: $img.naturalHeight,
            naturalWidth: $img.naturalWidth,
        });
    };
    handleClick = (e) => {
        if (this.props.isReadOnly) {
            return;
        }

        const $img = e.currentTarget,
            imgWidth = $img.clientWidth,
            x = e.pageX - $img.getBoundingClientRect().left - document.documentElement.scrollLeft,
            y = e.pageY - $img.getBoundingClientRect().top - document.documentElement.scrollTop,
            ratio = this.state.naturalWidth / imgWidth,
            actualX = Math.trunc(ratio * x),
            actualY = Math.trunc(ratio * y);

        this.addPeghole(actualX, actualY);
    };
    removeMarker = (id) => {
        if (this.props.isReadOnly) {
            return;
        }

        const pegholes = [...this.state.pegholes];
        pegholes.splice(id, 1);

        this.setState({
            pegholes,
            isDirty: true,
        });
        this.props.updateDirtyFlag(true);
    };
    updateType = (id, value) => {
        const pegholes = this.state.pegholes.map((p, index) => {
            if (index === id) {
                p.typeCode = value;

                return p;
            }

            return p;
        });

        this.setState({
            pegholes,
            isDirty: true,
        });
        this.props.updateDirtyFlag(true);
    };
    showPeghole = () => {
        this.setState({
            showPeghole: !this.state.showPeghole,
        });
    };
    render() {
        if (!this.props.shot.editedImageUris || !this.props.shot.editedImageUris.pegHoleCapture) {
            return (
                <div className="peghole txt-error">
                    <h4>Front Edited Shot required for peghole</h4>
                </div>
            );
        }

        const markers = this.state.pegholes.map((marker, index) => {
            return (
                <PegholeMarker
                    key={`${index}of${this.state.pegholes.length}`}
                    id={index}
                    top={(marker.y / this.state.naturalHeight) * 100 + "%"}
                    left={(marker.x / this.state.naturalWidth) * 100 + "%"}
                    typeCode={marker.typeCode}
                    updateType={this.updateType}
                    removeMarker={this.removeMarker}
                    isReadOnly={this.props.isReadOnly}
                />
            );
        });
        const pegholeClass = this.state.showPeghole ? "peghole-wrapper" : "peghole-wrapper hide";
        const headerClass = this.state.showPeghole ? "pegholeHeader -open" : "pegholeHeader -closed";
        const disabledClass = this.state.isDirty || this.props.isReadOnly ? "" : "-disabled";

        return (
            <div className="peghole">
                <div className={headerClass}>
                    <div className="button-group">
                        <h4 onClick={this.showPeghole}>
                            <FontAwesomeIcon icon={faChevronDown} /> Capture peghole
                        </h4>
                        <button className={`button -primary -right ${disabledClass}`} onClick={this.savePegholes} disabled={this.props.isReadOnly}>
                            Save
                        </button>
                    </div>
                </div>

                <div className={pegholeClass}>
                    {markers}
                    <img
                        onLoad={this.onLoad}
                        onMouseDown={(e) => {
                            e.preventDefault();
                        }}
                        onClick={this.handleClick}
                        alt={`Product ${this.props.shot.imageView}`}
                        src={this.props.shot.editedImageUris.pegHoleCapture}
                    />
                </div>
            </div>
        );
    }
}

export default PegholeCapture;
